import { render, staticRenderFns } from "./HighlightText.vue?vue&type=template&id=283800fb"
import script from "./HighlightText.vue?vue&type=script&lang=js"
export * from "./HighlightText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports